/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleMerchantDestinationSummaryData } from './GoogleMerchantDestinationSummaryData';
import {
    GoogleMerchantDestinationSummaryDataFromJSON,
    GoogleMerchantDestinationSummaryDataFromJSONTyped,
    GoogleMerchantDestinationSummaryDataToJSON,
    GoogleMerchantDestinationSummaryDataToJSONTyped,
} from './GoogleMerchantDestinationSummaryData';
import type { GoogleMerchantIssueSummaryData } from './GoogleMerchantIssueSummaryData';
import {
    GoogleMerchantIssueSummaryDataFromJSON,
    GoogleMerchantIssueSummaryDataFromJSONTyped,
    GoogleMerchantIssueSummaryDataToJSON,
    GoogleMerchantIssueSummaryDataToJSONTyped,
} from './GoogleMerchantIssueSummaryData';

/**
 * 
 * @export
 * @interface GoogleMerchantCatalogHealthData
 */
export interface GoogleMerchantCatalogHealthData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantCatalogHealthData
     */
    catalogueAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    catalogueCompleteness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    catalogueFetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    cataloguePublishedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    productCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    mappedProductCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    productsWithIssues?: number | null;
    /**
     * Products with at least one approved status and no disapproved status.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    eligibleProducts?: number | null;
    /**
     * Products eligible in at least one context or country and disapproved in another.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    limitedProducts?: number | null;
    /**
     * Products pending in all reported contexts and countries.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    pendingProducts?: number | null;
    /**
     * Products without an approved context and disapproved in at least one context or country.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    notEligibleProducts?: number | null;
    /**
     * Products without any reported destination status.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    unknownStatusProducts?: number | null;
    /**
     * Legacy count of products disapproved in at least one destination; not an aggregate product eligibility status.
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    disapprovedProducts?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    inStockProducts?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogHealthData
     */
    outOfStockProducts?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficCompleteness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficSince?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficUntil?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficTimeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    trafficFetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    clicks?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogHealthData
     */
    impressions?: string | null;
    /**
     * 
     * @type {Array<GoogleMerchantIssueSummaryData>}
     * @memberof GoogleMerchantCatalogHealthData
     */
    issueSummaries?: Array<GoogleMerchantIssueSummaryData>;
    /**
     * 
     * @type {Array<GoogleMerchantDestinationSummaryData>}
     * @memberof GoogleMerchantCatalogHealthData
     */
    destinationSummaries?: Array<GoogleMerchantDestinationSummaryData>;
}

/**
 * Check if a given object implements the GoogleMerchantCatalogHealthData interface.
 */
export function instanceOfGoogleMerchantCatalogHealthData(value: object): value is GoogleMerchantCatalogHealthData {
    return true;
}

export function GoogleMerchantCatalogHealthDataFromJSON(json: any): GoogleMerchantCatalogHealthData {
    return GoogleMerchantCatalogHealthDataFromJSONTyped(json, false);
}

export function GoogleMerchantCatalogHealthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantCatalogHealthData {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogueAvailable': json['catalogueAvailable'] == null ? undefined : json['catalogueAvailable'],
        'catalogueCompleteness': json['catalogueCompleteness'] === undefined ? undefined : json['catalogueCompleteness'] === null ? null : json['catalogueCompleteness'],
        'catalogueFetchedAt': json['catalogueFetchedAt'] === undefined ? undefined : json['catalogueFetchedAt'] === null ? null : json['catalogueFetchedAt'],
        'cataloguePublishedAt': json['cataloguePublishedAt'] === undefined ? undefined : json['cataloguePublishedAt'] === null ? null : json['cataloguePublishedAt'],
        'productCount': json['productCount'] === undefined ? undefined : json['productCount'] === null ? null : json['productCount'],
        'mappedProductCount': json['mappedProductCount'] === undefined ? undefined : json['mappedProductCount'] === null ? null : json['mappedProductCount'],
        'productsWithIssues': json['productsWithIssues'] === undefined ? undefined : json['productsWithIssues'] === null ? null : json['productsWithIssues'],
        'eligibleProducts': json['eligibleProducts'] === undefined ? undefined : json['eligibleProducts'] === null ? null : json['eligibleProducts'],
        'limitedProducts': json['limitedProducts'] === undefined ? undefined : json['limitedProducts'] === null ? null : json['limitedProducts'],
        'pendingProducts': json['pendingProducts'] === undefined ? undefined : json['pendingProducts'] === null ? null : json['pendingProducts'],
        'notEligibleProducts': json['notEligibleProducts'] === undefined ? undefined : json['notEligibleProducts'] === null ? null : json['notEligibleProducts'],
        'unknownStatusProducts': json['unknownStatusProducts'] === undefined ? undefined : json['unknownStatusProducts'] === null ? null : json['unknownStatusProducts'],
        'disapprovedProducts': json['disapprovedProducts'] === undefined ? undefined : json['disapprovedProducts'] === null ? null : json['disapprovedProducts'],
        'inStockProducts': json['inStockProducts'] === undefined ? undefined : json['inStockProducts'] === null ? null : json['inStockProducts'],
        'outOfStockProducts': json['outOfStockProducts'] === undefined ? undefined : json['outOfStockProducts'] === null ? null : json['outOfStockProducts'],
        'trafficAvailable': json['trafficAvailable'] == null ? undefined : json['trafficAvailable'],
        'trafficCompleteness': json['trafficCompleteness'] === undefined ? undefined : json['trafficCompleteness'] === null ? null : json['trafficCompleteness'],
        'trafficSince': json['trafficSince'] === undefined ? undefined : json['trafficSince'] === null ? null : json['trafficSince'],
        'trafficUntil': json['trafficUntil'] === undefined ? undefined : json['trafficUntil'] === null ? null : json['trafficUntil'],
        'trafficTimeZone': json['trafficTimeZone'] === undefined ? undefined : json['trafficTimeZone'] === null ? null : json['trafficTimeZone'],
        'trafficFetchedAt': json['trafficFetchedAt'] === undefined ? undefined : json['trafficFetchedAt'] === null ? null : json['trafficFetchedAt'],
        'clicks': json['clicks'] === undefined ? undefined : json['clicks'] === null ? null : json['clicks'],
        'impressions': json['impressions'] === undefined ? undefined : json['impressions'] === null ? null : json['impressions'],
        'issueSummaries': json['issueSummaries'] == null ? undefined : ((json['issueSummaries'] as Array<any>).map(GoogleMerchantIssueSummaryDataFromJSON)),
        'destinationSummaries': json['destinationSummaries'] == null ? undefined : ((json['destinationSummaries'] as Array<any>).map(GoogleMerchantDestinationSummaryDataFromJSON)),
    };
}

export function GoogleMerchantCatalogHealthDataToJSON(json: any): GoogleMerchantCatalogHealthData {
    return GoogleMerchantCatalogHealthDataToJSONTyped(json, false);
}

export function GoogleMerchantCatalogHealthDataToJSONTyped(value?: GoogleMerchantCatalogHealthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogueAvailable': value['catalogueAvailable'],
        'catalogueCompleteness': value['catalogueCompleteness'],
        'catalogueFetchedAt': value['catalogueFetchedAt'],
        'cataloguePublishedAt': value['cataloguePublishedAt'],
        'productCount': value['productCount'],
        'mappedProductCount': value['mappedProductCount'],
        'productsWithIssues': value['productsWithIssues'],
        'eligibleProducts': value['eligibleProducts'],
        'limitedProducts': value['limitedProducts'],
        'pendingProducts': value['pendingProducts'],
        'notEligibleProducts': value['notEligibleProducts'],
        'unknownStatusProducts': value['unknownStatusProducts'],
        'disapprovedProducts': value['disapprovedProducts'],
        'inStockProducts': value['inStockProducts'],
        'outOfStockProducts': value['outOfStockProducts'],
        'trafficAvailable': value['trafficAvailable'],
        'trafficCompleteness': value['trafficCompleteness'],
        'trafficSince': value['trafficSince'],
        'trafficUntil': value['trafficUntil'],
        'trafficTimeZone': value['trafficTimeZone'],
        'trafficFetchedAt': value['trafficFetchedAt'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'issueSummaries': value['issueSummaries'] == null ? undefined : ((value['issueSummaries'] as Array<any>).map(GoogleMerchantIssueSummaryDataToJSON)),
        'destinationSummaries': value['destinationSummaries'] == null ? undefined : ((value['destinationSummaries'] as Array<any>).map(GoogleMerchantDestinationSummaryDataToJSON)),
    };
}

